export const CreateNewAccountingEntityID: number = -4;
export const PleaseSelectID: string = "-1";
export const DefaultPrimaryAccountingTerm = "customer";

export const AccountingFieldNames = {
    PRIMARY: "linkingCustomer",
    SECONDARY: "linkingJob",
    ACTION: "linkingAction",
    LINK_TYPE: "linkingEntity",
} as const;
